import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Ellipsis } from "components/ui/Ellipsis";
import { BaseItemStyles } from "./BaseItemStyles";

import parseISO from "date-fns/parseISO";
import format from "date-fns/format";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import isToday from "date-fns/isToday";

export function BCalItem({ item }) {
  const {
    editor,
    title,
    link,
    changeState,
    allDayEvent,
    startTime: { dateTime: startTime } = {},
    endTime: { dateTime: endTime } = {},
    modifiedTime: { dateTime: modifiedTime } = {},
  } = item;

  const startAt = startTime && parseISO(startTime);
  const endAt = endTime && parseISO(endTime);
  const modifiedAt = modifiedTime && parseISO(modifiedTime);

  return (
    <BCalItemStyles>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: `flex`,
          justifyContent: `flex-start`,
          gap: `var(--md)`,
          alignItems: `flex-start`,
        }}
      >
        <BCalDateDisplay date={startAt} />
        <div>
          <Ellipsis>
            <strong>{title}</strong>
          </Ellipsis>
          <Ellipsis style={{ color: `var(--tundora)` }}>
            {allDayEvent && <span style={{ fontSize: `10px` }}>[all-day]</span>}{" "}
            {formatEventTime(startAt, allDayEvent, true)} -{" "}
            {formatEventTime(endAt, allDayEvent, false)}
          </Ellipsis>
          <Ellipsis
            style={{
              fontSize: `var(--tiny-font-size)`,
              color: `var(--dusty-gray)`,
            }}
          >
            {changeState === "new"
              ? `created by ${editor}`
              : `last ${changeState}`}{" "}
            &bull; {formatDistanceToNow(modifiedAt, { addSuffix: true })}
          </Ellipsis>
        </div>
      </a>
    </BCalItemStyles>
  );
}

const dateShape = PropTypes.shape({
  epoch: PropTypes.number,
});

BCalItem.propTypes = {
  item: PropTypes.shape({
    editor: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    changeState: PropTypes.string,
    startTime: dateShape,
    endTime: dateShape,
    modifiedTime: dateShape,
    allDayEvent: PropTypes.bool,
  }),
};

const BCalItemStyles = styled(BaseItemStyles)``;

const BCalDateDisplay = ({ date }) => {
  const month = format(date, "MMM");
  const weekDay = format(date, "EEE");
  const day = format(date, "dd");

  return (
    <BCalDateDisplayStyles>
      <div className="weekDay">{weekDay}</div>
      <div className="day">{day}</div>
      <div className="month">{month}</div>
    </BCalDateDisplayStyles>
  );
};

BCalDateDisplay.propTypes = {
  date: PropTypes.instanceOf(Date),
};

const BCalDateDisplayStyles = styled.div`
  width: 45px;
  border: 1px solid var(--silver);
  background-color: var(--wild-sand);
  color: var(--tundora);
  text-align: center;

  .weekDay {
    background-color: var(--calypso);
    color: white;
    font-size: 11px;
  }

  .day {
    font-size: 16px;
    font-weight: bold;
  }

  .month {
    font-size: 11px;
  }
`;

function formatEventTime(dateTime, allDayEvent, isStartOfRange) {
  if (isToday(dateTime)) {
    if (allDayEvent) {
      return "";
    }

    return format(dateTime, "h:mm aaaa");
  }

  if (allDayEvent) {
    return format(dateTime, "MM/dd(E)");
  }

  if (isStartOfRange) {
    return format(dateTime, "h:mm aaaa");
  } else {
    return format(dateTime, "(MM/dd) h:mm aaaa");
  }
}
